export default __webpack_public_path__ + "static/media/medical3.de9579fe.jpg";